/**
 * @file
 * Sticky pricing / CTA bar on exclusive offer pages until the request form is reached.
 */

/**
 * @param {HTMLElement} root
 * @returns {number}
 */
function zkOfferStickyTopOffset(root) {
  const docStyle = getComputedStyle(root);
  const toolbar = parseInt(docStyle.getPropertyValue('--zk-toolbar-offset') || '0', 10);
  const header = document.querySelector('.zk-header');
  const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
  return Math.max(toolbar, headerBottom, 0) + 8;
}

/**
 * @param {HTMLElement} shell
 */
function zkInitExclusiveOfferStickyPricing(shell) {
  const pricing = shell.querySelector('[data-zk-offer-pricing]');
  const placeholder = shell.querySelector('[data-zk-offer-pricing-placeholder]');
  const form = document.getElementById('community-offer-anfrage');

  if (!pricing || !placeholder || !form) {
    return;
  }

  const root = document.documentElement;
  let formInView = false;
  let isStuck = false;

  const syncTopVar = () => {
    root.style.setProperty('--zk-offer-sticky-top', `${zkOfferStickyTopOffset(root)}px`);
  };

  const stick = () => {
    if (isStuck || formInView) {
      return;
    }
    placeholder.style.height = `${pricing.offsetHeight}px`;
    placeholder.hidden = false;
    shell.classList.add('is-stuck');
    isStuck = true;
  };

  const unstick = () => {
    if (!isStuck) {
      return;
    }
    shell.classList.remove('is-stuck');
    placeholder.hidden = true;
    placeholder.style.height = '';
    isStuck = false;
  };

  const evaluateShell = () => {
    syncTopVar();
    if (formInView) {
      unstick();
      return;
    }
    const rect = shell.getBoundingClientRect();
    const top = zkOfferStickyTopOffset(root);
    if (rect.top < top && rect.bottom > top) {
      stick();
    }
    else if (rect.top >= top) {
      unstick();
    }
  };

  const formObserver = new IntersectionObserver(
    (entries) => {
      formInView = entries.some((entry) => entry.isIntersecting);
      if (formInView) {
        unstick();
      }
      else {
        evaluateShell();
      }
    },
    { threshold: 0.08, rootMargin: '0px 0px -15% 0px' },
  );

  formObserver.observe(form);

  window.addEventListener('scroll', evaluateShell, { passive: true });
  window.addEventListener('resize', evaluateShell, { passive: true });
  evaluateShell();
}

(function (Drupal, once) {
  Drupal.behaviors.zkExclusiveOfferStickyPricing = {
    attach(context) {
      once('zk-exclusive-offer-sticky-pricing', '[data-zk-offer-pricing-shell]', context).forEach(
        zkInitExclusiveOfferStickyPricing,
      );
    },
  };
})(Drupal, once);
